import * as React from 'react';
import { Textarea } from 'ui';
import { SHORT_DEBOUNCE_TIME } from '../constants';
import { SecondaryTextMode, TranslationRowProps } from '../types';
import { LanguageName } from './ui/language-name';

export class TranslationRow extends React.Component<TranslationRowProps> {

  private onPrimaryTextChange = (value: string) => {

    const { language, onPrimaryTextChange } = this.props;
    onPrimaryTextChange(language?.value, value);
  };

  private onSecondaryTextChange = (value: string) => {

    const { language, onSecondaryTextChange } = this.props;
    onSecondaryTextChange(language?.value, value);
  };

  public render() {
    const {
      language, primaryText, secondaryText, primaryTextMaxLength, secondaryTextMaxLength,
      secondaryTextMode, readOnly,
      primaryTextValidation, secondaryTextValidation,
      primaryTextLabel, secondaryTextLabel
    } = this.props;

    return (
      <div>
        <LanguageName
          text={language?.description}
          className="d-flex"
        />
        <div className="row">
          <div className={`col-lg-${secondaryTextMode !== SecondaryTextMode.disabled ? '6' : '12'} col-sm-12`}>
            <Textarea
              componentId={`primary_text_${language?.value}`}
              value={primaryText}
              onChange={this.onPrimaryTextChange}
              label={{ text: primaryTextLabel, required: !readOnly }}
              maxLength={primaryTextMaxLength}
              validation={primaryTextValidation}
              wait={SHORT_DEBOUNCE_TIME}
              readOnly={readOnly}
            />
          </div>
          {secondaryTextMode !== SecondaryTextMode.disabled && <div className="col-lg-6 col-sm-12">
            <Textarea
              componentId={`secondary_text_${language?.value}`}
              value={secondaryText}
              onChange={this.onSecondaryTextChange}
              label={{
                text: secondaryTextLabel,
                required: !readOnly && secondaryTextMode === SecondaryTextMode.required
              }}
              maxLength={secondaryTextMaxLength}
              validation={secondaryTextValidation}
              wait={SHORT_DEBOUNCE_TIME}
              readOnly={readOnly || secondaryTextMode === SecondaryTextMode.readOnly}
            />
          </div>}
        </div>
      </div>
    );
  }
}
